import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { proxyGlobalAuth } from '../../../../../../shared/proxies/proxyGlobalAuth'
import PlayIcon from '../../../../../../shared/components/ui/icons/PlayIcon'
import { recurringPaymentProxy } from '../../../../../../shared/proxies/recurringPaymentProxy'

interface ButtonProps {
  isEnded: boolean
}

function ResumeButton ({ isEnded }: ButtonProps): ReactElement {
  const { siteTheme: { buttonColors } } = useSnapshot(proxyGlobalAuth)

  return (
    <button
      disabled={isEnded}
      onClick={() => { recurringPaymentProxy.displayResumeModal = true }}
      type="button"
      className={cn(buttonColors.classes, 'disabled:bg-gray-200', 'text-white flex items-center justify-center py-2 px-4 mx-8 rounded')}
    >
      <span className="text-white mr-2">
        <PlayIcon color="#FFF" />
      </span>
      Resume
    </button>
  )
}

export default ResumeButton
